export default {
      id: "error-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#error",
      toString: function () {
        return this.url;
      }
    }